import Vue from 'vue'
import Router from 'vue-router'
import MEMO from './components/Home/MEMO.vue'
import Login from './components/Login/Login.vue'
import HomeAD from './components/Home.vue'
import CITHome from './components/Home/CITHome.vue'
import ACRHome from './components/Home/ACRHome.vue'
import USBRGAAPHome from './components/Home/USBRGAAPHome.vue'
import ACRAdmin from './components/Admin/ACRAdmin.vue'
import MEMOAdmin from './components/Admin/MEMOAdmin.vue'
import ACRAdminBuisnessRule from './components/Admin/ACRAdminBuisnessRule.vue'
import UserCreation from './components/Admin/UserCreation.vue'
import RegisterUser from './components/Login/RegisterUser.vue'
import AdminDashboard from './components/Admin/AdminDashboard.vue'
import AdminHeader from './components/Admin/FileHeader.vue'
import TransactionReports from './components/Admin/TransactionReports.vue'

Vue.use(Router)
const router = new Router({
    mode: 'history', // to get rid of hash in url
    hash: false,
    linkActiveClass: 'active',
    transitionOnLoad: true,
    routes: [
        {
            path: '/',
            name: 'HomeAD',
            component: HomeAD,
            meta: { requiresHeader: false, requireFooter: true, requiresAuth: false } // to disable header and footer from login page
        },
        {
            path: '/Login',
            name: 'LoginRedirect',
            component: Login,
            meta: { requiresHeader: false, requireFooter: false, requiresAuth: true }
        },
        {
            path: '/MEMO',
            name: 'MEMO',
            component: MEMO,
            meta: { requiresHeader: true, requireFooter: true, requiresAuth: false }
        },
        {
            path: '/CITHome',
            name: 'CITHome',
            component: CITHome,
            meta: { requiresHeader: true, requireFooter: true, requiresAuth: false }
        },
        {
            path: '/ACRHome',
            name: 'ACRHome',
            component: ACRHome,
            meta: { requiresHeader: true, requireFooter: true, requiresAuth: false }
        },
        {
            path: '/USBRGAAPHome',
            name: 'USBRGAAPHome',
            component: USBRGAAPHome,
            meta: { requiresHeader: true, requireFooter: true, requiresAuth: false }
        },
        {
            path: '/ACRAdmin',
            name: 'ACRAdmin',
            component: ACRAdmin,
            meta: { requiresHeader: true, requireFooter: true, requiresAuth: false }
        },
        {
            path: '/MEMOAdmin',
            name: 'MEMOAdmin',
            component: MEMOAdmin,
            meta: { requiresHeader: true, requireFooter: true, requiresAuth: false }
        },
        {
            path: '/ACRAdminBuisnessRule',
            name: 'ACRAdminBuisnessRule',
            component: ACRAdminBuisnessRule,
            meta: { requiresHeader: true, requireFooter: true, requiresAuth: false }
        },
        {
            path: '/UserCreation',
            name: 'UserCreation',
            component: UserCreation,
            meta: { requiresHeader: true, requireFooter: true, requiresAuth: false }
        },
        {
            path: '/RegisterUser',
            name: 'RegisterUser',
            component: RegisterUser,
            meta: { requiresHeader: false, requireFooter: false, requiresAuth: false }
        },
        {
            path: '/AdminDashboard',
            name: 'AdminDashboard',
            component: AdminDashboard,
            meta: { requiresHeader: true, requireFooter: true, requiresAuth: false }
        },
        {
            path: '/AdminHeader',
            name: 'AdminHeader',
            component:AdminHeader ,
            meta: { requiresHeader: true, requireFooter: true, requiresAuth: false }
        },
        {
            path: '/TransactionReports/:report',
            name: 'TransactionReports',
            component:TransactionReports ,
            meta: { requiresHeader: true, requireFooter: true, requiresAuth: false }
        } 
    ]
})
export default router
router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (localStorage.getItem('token') == null || localStorage.getItem('userName') == null) {
            next({
                name: 'Login',
                query: { redirect: to.fullPath }
            })
        }
        else {
            next()
        }
    }
    else {
        next()
    }
})